export const MAX_NAME_LENGTH = 10;

/** Number of skeleton rows shown while tags are loading (matches sidebar tag list size). */
export const SKELETON_TAG_ROWS = 3;
